/**
 * @auth 赖传峰
 * @date 2021/12/29
 */
import type { CSSProperties } from 'vue'

export const enum ContextMenuPositionPreference {
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
}

export interface ContextMenuExpose {
  close(): void

  /* preference 更倾向于定位在菜单的哪个位置 */
  show(coordinate: { x: number; y: number; preference?: ContextMenuPositionPreference }, ids?: string[]): void

  dom(): HTMLElement | undefined
}

export interface ContextMenuState {
  visible: boolean
  position: { left: number; top: number }
  transformOrigin: CSSProperties['transform-origin']
  ids: string[] // 当前操作对象的 id，文件或者文件夹
}

export const enum Operation {
  OPEN = 'OPEN',
  RESTORE = 'RESTORE',
  REPORT = 'REPORT',
  DOWNLOAD_GUIDE = 'DOWNLOAD_GUIDE',
}

export const enum OperationGroup {
  NORMAL = 'normal',
  STATUS = 'status',
}

export interface OperationMeta<C = unknown> {
  group?: string
  operation?: Operation | string
  labelI18nKey: string
  icon: IconComponent
  limit(contexts: C | C[], ids?: string[], showRestoreStatus?: boolean): boolean
  keyboard?: string // 快捷键提示
  hideInBottom?: boolean // 底部是否隐藏
}

export default {}
